import React from 'react';
import PropTypes from 'prop-types';
import HeaderLeft from './HeaderLeft';
import HeaderRight from './HeaderRight';

function TopHeader({ sidebarOpen = false, onToggleSidebar = () => {}, pageTitle = '', pageIcon = '' }) {
  return (
    <header className="top-header">
      <HeaderLeft 
        sidebarOpen={sidebarOpen}
        onToggleSidebar={onToggleSidebar}
        pageTitle={pageTitle}
        pageIcon={pageIcon}
      />
      <HeaderRight />
    </header>
  );
}

TopHeader.propTypes = {
  sidebarOpen: PropTypes.bool,
  onToggleSidebar: PropTypes.func,
  pageTitle: PropTypes.string,
  pageIcon: PropTypes.string
};

TopHeader.defaultProps = {
  sidebarOpen: false,
  onToggleSidebar: () => {},
  pageTitle: '',
  pageIcon: ''
};

export default TopHeader;